import {
    TOGGLE_DEVICE_PUBLIC_ERROR,
    TOGGLE_DEVICE_PUBLIC_START,
    TOGGLE_DEVICE_PUBLIC_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.togglePublic, action = {type: ''}) => {
    switch (action.type) {
        case TOGGLE_DEVICE_PUBLIC_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case TOGGLE_DEVICE_PUBLIC_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case TOGGLE_DEVICE_PUBLIC_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/togglePublicDeviceReducer.js